export default class AbstractCountryRepresentation {
  _code;

  setCode(code) {
    this._code = code;
  }
}
